var app = angular.module("leonardo");

var PortfolioList = function($scope, PortfolioService, ngDialog, AuthDataService, $rootScope, PermissionService,
                             FilterService, AccountUserService, $timeout, $q, $controller, FilterService, $filter) {
  $scope.permissionService = PermissionService;
  $scope.portfolios = [];
  $scope.grouped = [];
  $scope.expanded = false;
  $scope.valid_portfolios = [];

  $scope.expand = function() {
    if ($scope.expanded) {
      $scope.expanded = false;
    }
  };

  $scope.isValidPortfolio = function (portfolio) {
    return _.contains($scope.valid_portfolios, portfolio.id) || (AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) ||
      (AccountUserService.currentAccountUser.is_owner);
  };

  $scope.indexGroupAccount = function(account) {
    var index = -1;
    angular.forEach($scope.grouped, function(group, key) {
      if (group.account === account) {
        index = key;
      }
    });
    return index;
  };

  $scope.groupGroups = function(results){
    $scope.grouped = [];
    angular.forEach(results, function(data){
      var index = $scope.indexGroupAccount(data.account);
      if(index < 0) {
        $scope.grouped.push({ account: data.account, portfolios: [] });
        index = $scope.grouped.length-1;
      }
      $scope.grouped[index].portfolios.push(data);
    });
  };

  $scope.getEntitiesPromise = function (options) {
    var defer = $q.defer();
    // AccountUserService.getCurrent().then(function () {
      if (FilterService.hasFilter('account_reports')) {
        options['account'] = FilterService.getFilter('account_reports');
      }
      if (FilterService.hasFilter('managed_by_reports')) {
        options['managed_by'] = FilterService.getFilter('managed_by_reports');
      }
      if (FilterService.hasFilter('group_reports')) {
        options['group'] = FilterService.getFilter('group_reports');
      }
      if (FilterService.hasFilter('search')) {
        options['search'] = FilterService.getFilter('search');
      }
      if (FilterService.hasFilter('levels')) {
        options['levels'] = FilterService.getFilter('levels');
      }
      options['ordering'] = 'account,name';
      PortfolioService.getlist(options, true).then(function (list) {
        $scope.groupGroups(list.results ? list.results : list);
        $scope.portfolios = list;
        $scope.valid_portfolios = [];
        angular.forEach(AccountUserService.currentAccountUsers, function (currentAccountUser) {
          // get the list of portfolios as per account
          let currentAccountPortfolios = $filter('filter')(FilterService.portfolios, {
            account: currentAccountUser.account,
          });
          angular.forEach(currentAccountPortfolios, function (value) {
            $scope.valid_portfolios.push(value.id);
          });
        });
        if ((localStorage.getItem("last_login") === null) && ($scope.portfolios.length === 0)) {
          ngDialog.open({ template: 'views/templates/dialog/portfolio/onboarding-help.html'});
          localStorage.setItem('last_login', true);
        }
        defer.resolve($scope.portfolios);
      });
    return defer.promise;
  };

  $controller('TableFilterController', {$scope: $scope});

  $scope.$on('property:moved', function($event, portfolio_from, portfolio_destiny){
    angular.forEach($scope.portfolios, function(value, key){
      if ((value.id === portfolio_from) || (value.id === portfolio_destiny)) {
        PortfolioService.get(value.id, true).then(function (data) {
          property_count(value, key, data);
        });
      }
    });
  });

  $scope.$on('portfolio:added', function() {
    $scope.loadPage($scope.page);
  });

  $scope.$on('portfolio:deleted', function(event, portfolio) {
    $scope.loadPage($scope.page);
    if (FilterService.currentProperty) {
      if (FilterService.currentProperty.portfolio === portfolio.id) {
        FilterService.resetPortfolios();
      }
    }
  });

  $scope.$on('portfolio:updated', function() {
    $scope.loadPage($scope.page);
  });

  $scope.$on('property:deleted', function($event, property) {
    angular.forEach($scope.portfolios, function(value, key){
      if ((value.id === property.portfolio)) {
        PortfolioService.get(value.id).then(function (data) {
          property_count(value, key, data);
        });
      }
    });
    if (FilterService.currentProperty.id === property.id) {
      FilterService.resetProperties();
    }
  });

  function property_count(value, key, data) {
    $scope.portfolios[key].property_count = data.property_count;
    var index = $scope.indexGroupAccount(data.account);
    angular.forEach($scope.grouped[index].portfolios, function (portfolio, keyGroup) {
      if (value.id === portfolio.id) {
        $scope.grouped[index].portfolios[keyGroup].property_count = data.property_count;
      }
    });
  }

  $scope.$on('filter-selection:updated', function($event, key, value) {
    $scope.loadPage(1);
  });

  $timeout(function () {
    $scope.loadPage(1);
  }, 0);

};

app.controller('PortfolioList', ['$scope', 'PortfolioService', 'ngDialog', 'AuthDataService', '$rootScope',
  'PermissionService', 'FilterService', 'AccountUserService', '$timeout', '$q', '$controller', 'FilterService', '$filter', PortfolioList]);
